import {isCtrlOrCmd, copyText} from './utils';

export default function() {
    $('.copy-icon').click(function(e) {
      e.preventDefault();
      const includeTitle = isCtrlOrCmd(e);

      let taskElement = $(this).parents('a');
      let href = taskElement.attr('href');
      let fullTitle = $(this).parent().find('#link-title').html();
      let taskNumber = fullTitle.split(' ')[0];

      let url = `${window.location.origin}${href}`;
      let markdown = `[${includeTitle ? fullTitle : taskNumber}](${url})`;
      copyText(markdown);

      let icon = $(this).find('i');
      icon.removeClass('fa-link')
        .addClass('fa-check')
        .addClass('text-success');

      setTimeout(function() {
        icon.addClass('fa-link')
          .removeClass('fa-check')
          .removeClass('text-success');
      }, 2000);
    });
}



// WEBPACK FOOTER //
// ./assets/js/dashboard.js